import type { ReactFCC } from 'types/react';

import { Suspense } from 'react';

const SuspenseWrapper: ReactFCC = ({ children }) => <Suspense>{children}</Suspense>;

export default SuspenseWrapper;
